import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

/** Inline empty state with a clear next step. Lives inside the table/list container, not as a separate card. */
export const EmptyState = ({ icon: Icon = Inbox, title, text, action, compact = false, className, testId = "admin-empty-state" }) => (
  <div className={cn("flex flex-col items-center px-6 text-center", compact ? "py-10" : "py-16", className)} data-testid={testId}>
    <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-secondary text-muted-foreground" aria-hidden="true"><Icon className="h-5 w-5" strokeWidth={1.75} /></div>
    <h3 className="font-display text-base font-semibold">{title}</h3>
    {text && <p className="mt-1.5 max-w-md text-sm leading-relaxed text-muted-foreground">{text}</p>}
    {action && <div className="mt-5 flex flex-wrap justify-center gap-2">{action}</div>}
  </div>
);
